// extracted by mini-css-extract-plugin
export default {"wrapper":"Questionnaire_wrapper__bgdqh","questionnaire":"Questionnaire_questionnaire__4TCjT"};